import axios from 'axios';

export interface Tag {
  id: number;
  name: string;
  video_count: number;
}

export interface TagsResponse {
  data: Tag[];
  total: number;
}

export const fetchTags = async (skip: number = 0, limit: number = 12): Promise<TagsResponse> => {
  const response = await axios.get('/api/tags/', {
    params: { skip, limit }
  });
  // console.log(new Array(response.data))
  return response.data;
};